import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogPipe } from './log.pipe';
import { AgePipe } from './age.pipe';
import { HumanizeBytesPipe } from './humanize-bytes.pipe';



@NgModule({
    exports: [
        LogPipe,
        AgePipe,
        HumanizeBytesPipe
    ],
    imports: [
        CommonModule,
        LogPipe,
        AgePipe,
        HumanizeBytesPipe
    ],
})
export class PipesModule { }
